import { useState } from "react";
import SectionHead from "./SectionHead";
import { faqs } from "@/mocks/homeData";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-24" aria-label="常见问题">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <SectionHead
          eyebrow="常见问题"
          title="投稿前，你想问的都在这里"
          desc="关于匿名、审核、格式与删改的疑问，我们整理成 FAQ 放在这里，投稿前看一眼更安心。"
        />

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                >
                  <h3 className="font-serifsc text-base font-bold text-foreground-950 md:text-lg">{f.q}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      open ? "bg-primary-500 text-white" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-lg`} aria-hidden="true"></i>
                  </span>
                </button>
                {open && (
                  <p className="border-t border-background-200 px-5 pb-5 pt-4 text-sm leading-relaxed text-foreground-600 md:px-6">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}